<!--
 * @Description: tab组件
 * @Date: 2021-02-01 12:33:34
-->
<template>
  <div class="home-tab">
    <ul class="home-tab__first">
      <li
        v-for="(item,index) in firstTabs"
        :key="index"
        @click="changeFirst(item,index)"
      >{{item}}</li>
    </ul>
    <ul class="home-tab__second" v-if="~firstActiveIndex">
      <li v-for="(item,index) in secondTabs" :key="index">{{item}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'HomeTab',
  data() {
    return {
      firstTabs: [
        '点播',
        '直播',
        '病历',
        '资讯',
        '点播',
        '点播',
        '直播',
        '病历',
        '资讯',
        '点播'
      ],
      secondTabs: ['点播', '直播', '病历', '资讯'],
      firstActiveIndex: -1
    };
  },
  components: {},
  watch: {},
  computed: {},
  methods: {
    changeFirst(item, index) {
      this.firstActiveIndex = index;
    }
  },
  created() {
  },
  beforeDestroy() {}
};
</script>

<style scoped lang='scss'>
.home-tab {
  overflow: hidden;
  &__first {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 8px;
    overflow-x: auto;
    overflow-y: hidden;
    user-select: none;
    word-break: break-all;
    text-size-adjust: 100%;
    li {
      padding: 0 0.67rem;
      font-size: 0.37rem;
      color: #666666;
      flex: 1 0 auto;
      display: flex;
      flex-basis: auto;
      flex-grow: 1;
      flex-shrink: 0;
      overflow-wrap: break-word;
      &:last-child {
      }
    }
  }
  &__second {
    @extend .home-tab__first;
    margin-top: 0.2rem;
    background: #ededed;
    li {
      font-size: 0.28rem;
      color: #666666;
    }
  }
}
</style>